import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import {DataSourcesComponent} from '@features/data-tracing/components/data-sources/data-sources.component';
import {DataSourcesFieldHistoryDetailsComponent} from '@features/data-tracing/components/data-sources-field-history-details/data-sources-field-history-details.component';
import {DataSourcesRootComponent} from "@features/data-tracing/components/data-sources-root/data-sources-root.component";
import {LatestDataSourcesComponent} from "@features/data-tracing/components/latest-data-sources/latest-data-sources.component";

// @dynamic
export class DataTracingDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (DataTracingDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['DataSourcesRootComponent'] = DataSourcesRootComponent;
    components['DataSourcesComponent'] = DataSourcesComponent;
    components['LatestDataSourcesComponent'] = LatestDataSourcesComponent;
    components['DataSourcesFieldHistoryDetailsComponent'] = DataSourcesFieldHistoryDetailsComponent;

    DataTracingDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static register(key: string, component: any) {
    DataTracingDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
  public static getComponentArray (): any[] {
    DataTracingDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(DataTracingDynamicComponentHelper.components).forEach(key => {
      componentArray.push(DataTracingDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
